var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.68421 8.7661L4.0656 6.3847L6.0452 8.365L8.2551 6.1551L7 4.9H10.5V8.4L9.2449 7.1449L6.0452 10.3446L4.0656 8.365L2.3331 10.0968C3.11949 11.2804 4.32644 12.1208 5.70937 12.4476C7.09229 12.7745 8.54776 12.5634 9.78083 11.8571C11.0139 11.1508 11.9323 10.0021 12.3501 8.64389C12.7678 7.28564 12.6535 5.81938 12.0304 4.54225C11.4073 3.26512 10.3219 2.27264 8.99433 1.76592C7.66672 1.2592 6.19612 1.27615 4.88053 1.81333C3.56495 2.35051 2.50279 3.36774 1.90928 4.65889C1.31577 5.95004 1.23531 7.41854 1.68421 8.7668V8.7661ZM0.607606 9.8567L0.600605 9.8497L0.603405 9.8469C0.204356 8.95091 -0.00125139 7.98084 5.73004e-06 7C5.73004e-06 3.1339 3.1339 0 7 0C10.8661 0 14 3.1339 14 7C14 10.8661 10.8661 14 7 14C4.151 14 1.70101 12.299 0.607606 9.8567Z",
    fill: "#6B758B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.502fb89b672fe61c53beaaa2bc96ba80.svg";
export { ForwardRef as ReactComponent };